import { Switch, Route, Redirect } from "react-router"
import { Tabs, Tab, Content } from "./VerticalTabs.style"
import Div100vh from "react-div-100vh"
import { AnimatePresence } from "framer-motion"
const VerticalTabs = ({ path, tabs }) => (
  <Div100vh>
    <Tabs>
      {tabs.map(({ name }, index) => (
        <Tab
          key={index}
          to={`${path}/${name.toLowerCase()}`}
          width={100 / tabs.length}
        >
          {name}
        </Tab>
      ))}
    </Tabs>
    <Content>
      <AnimatePresence>
        <Switch>
          {tabs.map(({ name, component: Component }, index) => (
            <Route key={index} path={`${path}/${name}`} component={Component} />
          ))}
          <Route
            render={() => (
              <Redirect to={`${path}/${tabs[0]?.name?.toLowerCase()}`} />
            )}
          />
        </Switch>
      </AnimatePresence>
    </Content>
  </Div100vh>
)

export default VerticalTabs
